// JavaScript Document




function headerSlider() {

    function initVideoScene(container, video, swiper, swipertype = false, isAutoplay = false) {

        

        // clean up old play-but 
        const oldPlaybut    = container.querySelector('.btn-play');
        const autoplay      =  video.dataset.autoplay;
        const activeSlide   = container.querySelector('.swiper-slide-active');
       

        const slideEffect = activeSlide.dataset.effect;


        if (oldPlaybut) {
            oldPlaybut.remove();
        }

   

        // append new play-but

        appendHtml(container, '<a href="javascript:;" class="btn-play d-none" ><span class="visually-hidden-focusable">Play</span></a>');
        appendHtml(container, '<a href="javascript:;" class="btn-pause d-none" ><span class="visually-hidden-focusable">Pause</span></a>');

        const playBut =  container.querySelector('.btn-play');
        const pauseBut =  container.querySelector('.btn-pause');

        gsap.to(playBut,{
            scale: 1.1, 
            duration: 0.25,
            yoyoEase: Power3.easeOut, 
            repeat: 2, 
            delay:0.5,
            //repeatDelay: 0.1,
            onComplete: function() {

                gsap .to(playBut,{
                    scale: 1, 
                    duration: 0.25,
                    ease:  Power3.easeOut
                })

            }
            
        });


        function removePlaybut(){

            playBut.remove();
            pauseBut.remove();
        }

        function setPlaybut(state){

            if (state === 'play') {

                playBut.classList.add('d-none');
                pauseBut.classList.remove('d-none');

            } else {

                playBut.classList.remove('d-none');
                pauseBut.classList.add('d-none');
            }
        }

        function playVideo(video,isAutoplay) {

            if (swiper) {
                swiper.autoplay.stop()
            }
            var isPlaying = video.currentTime > 0 && !video.paused && !video.ended 
                && video.readyState > video.HAVE_CURRENT_DATA;

            if (!isPlaying) {

                setPlaybut('play');
                setTimeout(function(){
                    video.play();
                },100);

                if (isAutoplay) {

                  

                    video.addEventListener('ended',function(){
                       
                        swiper.autoplay.start();

                    },false);


                }

                
            }


            

            if (slideEffect === 'moebiusband') {

                let oldTitle;
                let headerTitleSpan = document.querySelector('#masthead .header-title span');

           
                function setTitle(title) {

                    if (oldTitle != title) {

                        headerTitleSpan.textContent = ': '+title;
                    }

                    oldTitle = title;

                }

                function clearTitle() {       

                    headerTitleSpan.textContent = ''; 

                }

           
                video.addEventListener('timeupdate', function(){


                    let time = parseFloat(video.currentTime).toFixed(1);

           

                    if (time >= 0 && time <= 1) { 
                        setTitle(data['simultaneousEngineering']);
                    } 
                    if (time >= 2.66 && time <= 3.5) {
                        setTitle(data['stanztechnik']);
                    } 
                    if (time >= 5.31 && time <= 5.6)  {
                        setTitle(data['oberflaechentechnik']);
                    } 
                    if (time >= 9.15 && time <= 9.5) {
                        setTitle(data['kunststofftechnik']);
                    }
                 
                    if (time >= 11.57 && time <= 11.9) {
                        setTitle(data['montagetechnik']);
                    }
                    
                    if (time >= 13.5 && time <= 13.9) {
                        setTitle(data['aetztechnik']);
                    } 
                    if (time >= 16.4 && time <= 16.9) {
                        setTitle(data['prueftechnik']);
                    }
                    if (time >= 18.5) {
                        clearTitle();
                    }


                   
                


                    //displaySubtitle(video.currentTime);
                });
             
                /*
                setInterval( function() {
                    
                    let time = parseFloat(video.currentTime).toFixed(2);

                    console.log(time);

                    if (time >= 0 && time <= 1) { 
                        setTitle('Simultaneous Engineering');
                    } 
                    if (time >= 2.8 && time <= 3) {
                        setTitle('Stanztechnik');
                    } 
                    if (time >= 4.7 && time <= 4.9)  {
                        setTitle('Oberflächentechnik');
                    } 
                    if (time >= 7.86 && time <= 8) {
                        setTitle('Kunststofftechnik');
                    }
                 
                    if (time >= 9.6 && time <= 9.8) {
                        setTitle('Montagetechnik');
                    }
                    
                    if (time >= 11.00 && time <= 11.2) {
                        setTitle('Ätztechnik');
                    } 
                    if (time >= 13.25 && time <= 13.4) {
                        setTitle('Prüftechnik');
                    }

                
                
                }, 5);
*/


             
            }


           
        }

        function pauseVideo(video, isAutoplay) {

            var isPlaying = video.currentTime > 0 && !video.paused && !video.ended 
                && video.readyState > video.HAVE_CURRENT_DATA;
                setPlaybut('pause');
            if (isPlaying) {
                video.pause();
                if (isAutoplay) {
                    swiper.autoplay.start();
                }
            }

        }

        playBut.addEventListener('click', function(){
            playVideo(video, false);
        });

        pauseBut.addEventListener('click', function(){
            pauseVideo(video, isAutoplay);
        });

        video.addEventListener('ended', function(e) {

            setPlaybut('pause');

        });

        video.addEventListener('pause', function(e) {

            setPlaybut('pause');

        });
        video.addEventListener('playing', function(e) {

            setPlaybut('play');

        });
        

        if (autoplay) {

            if (swiper.autoplay.running) { 

                playVideo(video, true);

            } else {

                playVideo(video, false);

            }

        } else {
            playBut.classList.remove('d-none');
        }
        
       


        return {

        }
    }

    function setSlideEffect(slide,effect) {

        


        let masterTl = new gsap.timeline({paused:true});

        if (effect === 'scrollup') {

            

            const slideImage = slide.querySelector('img');

            

            const slideHeight = offsetDimension(slide).height;
            const slideImageHeight = offsetDimension(slideImage).height;
            const diff = slideImageHeight-slideHeight;


            masterTl.to(slideImage, {y: -diff+'px', duration: 25,  ease: 'power1.inOut'});

            masterTl.play();
        }

    }

    function setParallaxEffect(swiperContainer) {




        if (!isMobile) {

            let headerTitle = document.querySelector('#masthead .header-title');

            gsap.to(headerTitle,{ 
                y: 100,
                //alpha: 0,
        
                    // rotationZ: 6,
                    //  scale:1.1,
                
                scrollTrigger: {
                    start: "top top",
                    //ennd: "bottom top",
                    trigger: swiperContainer,
                    scrub: true,
        
                }
             });

        }
        
       
         

        gsap.fromTo(swiperContainer,{ 
        y: 0,

            // rotationZ: 6,
            //  scale:1.1,
        }, {
        scrollTrigger: {
            start: "top top",
            trigger: swiperContainer,
            scrub: true,

        },
        y: 100,
        // scale:1,
            // rotationZ: 0,
        ease: "none"
        });


    }

    function setCaption(caption,headerSliderCaption) {

        
        headerSliderCaption.innerHTML = '';

        if (caption) {
            headerSliderCaption.innerHTML = caption; 
        }

    }

    function initSwiper(headerSliderHolder, swipertype = false) {

        const swiperContainer              = headerSliderHolder.querySelector('#header-swiper');

        const swiperPaginationHolder      = headerSliderHolder.querySelector('.swiper-pagination-holder ');
        const pagination                  = swiperPaginationHolder.querySelector('.swiper-pagination');
        const swiperButtonHolder          = headerSliderHolder.querySelector('.swiper-button-holder');
        const headerSliderCaption         = headerSliderHolder.querySelector('.header-slider-caption');

        const headerSliderAutoplayDelay    = swiperContainer.dataset.autoplay;
        const headerSliderSlideEffect      = swiperContainer.dataset.slideEffect;
        const headerSliderPageId           = swiperContainer.dataset.pageId;


        const headerVideos  = swiperContainer.querySelector('video');
        const slides        = swiperContainer.querySelectorAll('.swiper-slide');

        


        let config = {
            pagination: {
                el: pagination,
                clickable: true,
               // dynamicBullets: true,
                dynamicMainBullets: 20,
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            effect: headerSliderSlideEffect,
        }

        if (headerSliderAutoplayDelay) {

            config = {
                pagination: {
                    el: pagination,
                    clickable: true,
                   // dynamicBullets: true,
                    dynamicMainBullets: 20,
                },
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                autoplay: {
                    delay: headerSliderAutoplayDelay,
                    disableOnInteraction: true,
                },
                effect: headerSliderSlideEffect,
            }
        }

        const swiper = new Swiper(swiperContainer, config);


        swiper.on('slideChange', function (e) {

            const oldPlaybut = swiperContainer.querySelector('.btn-play');
            const oldPauseBut = swiperContainer.querySelector('.btn-pause');
            if (oldPlaybut) {
                oldPlaybut.remove();
            }
            if (oldPauseBut) {
                oldPauseBut.remove();
            }


            const activeSlide = slides[e.activeIndex];

            // videos

            let currentVideo = false;

            currentVideo = activeSlide.querySelector('video');

            if (currentVideo) {

                var isPlaying = currentVideo.currentTime > 0 && !currentVideo.paused && !currentVideo.ended 
                && currentVideo.readyState > currentVideo.HAVE_CURRENT_DATA;
                if (isPlaying) {
                    currentVideo.pause();
                }

                const videoScene = new initVideoScene(swiperContainer, currentVideo, swiper, swipertype,headerSliderAutoplayDelay);
            }

            // effects

            const slideEffect = activeSlide.dataset.effect;

            setSlideEffect(activeSlide,slideEffect);

            // caption

            if (headerSliderCaption) {
             
                let caption = activeSlide.dataset.caption;
                setCaption(caption,headerSliderCaption);
               
            }

        });

        swiper.on('afterInit', function (e) {

            initPaginationFix(pagination,swiperButtonHolder);      

        });

        swiper.on('resize', function (e) {

            initPaginationFix(pagination,swiperButtonHolder);     

        });

        




        const activeSlide = slides[0];
        const initialVideo = activeSlide.querySelector('video');

        if (initialVideo) {

            const videoScene = new initVideoScene(swiperContainer, initialVideo, swiper,swipertype,headerSliderAutoplayDelay);
        }

        const slideEffect = activeSlide.dataset.effect;

        if (slideEffect) {

            setSlideEffect(activeSlide,slideEffect);
        }

        if (swipertype === 'pageheader') {

            setParallaxEffect(swiperContainer);

        }

        if (headerSliderCaption) {
             
            let caption = activeSlide.dataset.caption;
            setCaption(caption,headerSliderCaption);
           
        }

       
        


        //initPaginationSlider(headerSliderHolder,swiper);

 

    }

    function initPaginationFix(pagination,swiperButtonHolder) {

        let swiperPaginationBullet          = pagination.querySelector('.swiper-pagination-bullet');
        let swiperPaginationBulletLength    = pagination.querySelectorAll('.swiper-pagination-bullet').length;

        let swiperPaginationBulltswidth     = getAbsolutewidth(swiperPaginationBullet)*swiperPaginationBulletLength;
        let paginationWidth                 = pagination.offsetWidth;

        if (swiperPaginationBulltswidth >= paginationWidth) {
            pagination.classList.add('invisible');
            swiperButtonHolder.classList.remove('invisible');
        } else {
            pagination.classList.remove('invisible');
            swiperButtonHolder.classList.add('invisible');
        }

        //getAbsolutewidth(el)

    }

    function initPaginationSlider(headerSliderHolder,swiper) {

        let swiperPaginationHolder      = headerSliderHolder.querySelector('.swiper-pagination-holder');
        let swiperPaginationSlider      = swiperPaginationHolder.querySelector('.swiper-pagination-slider');
        let swiperPagination            = swiperPaginationHolder.querySelector('.swiper-pagination');

        console.log(swiperPaginationHolder,swiperPaginationSlider,swiperPagination);

    }
   
    return {
        init: initSwiper
    };
}
